import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as BiIcons from "react-icons/bi";


export const SidebarData = [
  {
    title: "Home",
    path: "/",
    icon: <AiIcons.AiFillHome />,
    cName: "nav-text",
  },
  {
    title: "Planos Internet",
    path: "/internet",
    icon: <AiIcons.AiOutlineInfoCircle />,
    cName: "nav-text",
  },

  {
    title: "TV por Assinatura",
    path: "/tvs",
    icon: <BiIcons.BiChalkboard />,
    cName: "nav-text",
  },

  {
    title: "Telefonia Fixa",
    path: "/telefones",
    icon: <BiIcons.BiPhoneCall />,
    cName: "nav-text",
  },

  {
    title: "Aplicativos",
    path: "/apps",
    icon: <FaIcons.FaAppStore />,
    cName: "nav-text",
  },

  {
    title: "Noções de Redes",
    path: "/rede",
    icon: <AiIcons.AiOutlineApartment />,
    cName: "nav-text",
  },

  {
    title: "Siglas e Significados",
    path: "/siglas",
    icon: <AiIcons.AiOutlineQuestionCircle />,
    cName: "nav-text",
  },

  {
    title: "Conformidade",
    path: "/normas",
    icon: <FaIcons.FaGavel />,
    cName: "nav-text",
  },
  
];
